// `WHISTLEBLOWING_SPECIFIC_METRICS` ---- this field lists all disabled metrics for the dashboard for non whistleblowing
export const WHISTLEBLOWING_SPECIFIC_METRICS = [
  'Confidentiality',
  'Findings',
  'Suspected Department',
];

export const CHANNEL_TYPE = { INTERNAL: 1, CUSTOMER: 2 };

const CAPITALIZED_WORLDS = ['ai'];

//USED TO CAPITALIZE A WORD ON A CHANNEL RG. AI governance
export function capitalizeWords(inputString: string) {
  if (typeof inputString !== 'string' || !Array.isArray(CAPITALIZED_WORLDS)) {
    return inputString;
  }
  return inputString.split(' ').map(word => {
    return CAPITALIZED_WORLDS.includes(word.toLowerCase())
      ? word.toUpperCase()
      : word;
  }).join(' ');
}
